// STYLES
import '@/assets/scss/main.scss'

import Vue, { CreateElement, VNode } from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import MainLayout from './shared/layouts/MainLayout.vue'
import TooltipComponent from './shared/components/TooltipComponent.vue'
import VueMq from 'vue-mq'
import * as VueGoogleMaps from 'vue2-google-maps'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

Vue.use(VueMq, {
  breakpoints: {
    mobile: 320,
    tablet: 740,
    desktop: 980,
    tabletLandscape: 1024,
    wide: 1300
  }
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCTvWb8SR9AQBRkAsytfAA7i3ZkUq-Nsnc',
    libraries: 'places' // necessary for places input
  }
})

Vue.config.productionTip = false

Vue.component('main-layout', MainLayout)
Vue.component('ldw-tooltip', TooltipComponent)

const app = new Vue({
  router,
  store,
  render: (h: CreateElement): VNode => h(App)
}).$mount('#app')
